import { MathUtils } from "three";
import { Line2 } from "three/examples/jsm/lines/Line2";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
import Formatting from "../../Helpers/Formatting";
import { SVGLabel } from "../../Overlays/SVGObjects";
import { SVGOverlay } from "../../Overlays/SVGOverlay";
import { ViewerLayers } from "../../Enums/ViewerLayers";
import { BaseMeasurement,  EMeasurementColors, MeasurementData } from "./BaseMeasurement";
import * as THREE from 'three';

export class AngleMeasurement extends BaseMeasurement {

    constructor(formatter: Formatting, startPos: THREE.Vector3, endPos: THREE.Vector3, startNormal: THREE.Vector3, endNormal: THREE.Vector3) {
        super(formatter, startPos, endPos, startNormal, endNormal);
        let midpoint = startPos.clone().add(endPos).divideScalar(2);
        try {
            // Start and end point
            this._startPos = startPos.clone().sub(midpoint);
            this._endPos = endPos.clone().sub(midpoint);
            this._startNormal = startNormal;
            this._endNormal = endNormal;
            this.value = this._startNormal.angleTo(this._endNormal) * MathUtils.RAD2DEG;

            var newPoints: number[];
            if (this._startPos.distanceToSquared(this._endPos) < 1) {
                newPoints = [this._startPos.x, this._startPos.y, this._startPos.z];
            }
            else {
                // Getting arc point based on the 2 normals

                // Getting the intersection point
                let planeControl = new THREE.Plane();
                planeControl.setFromNormalAndCoplanarPoint(endNormal, this._startPos);
                let controlPoint: THREE.Vector3 = new THREE.Vector3();
                planeControl.projectPoint(this._endPos, controlPoint);


                // Making an arc for the angle
                const spline = new THREE.QuadraticBezierCurve3(this._startPos, controlPoint, this._endPos);

                // Getting the intersection point
                let plane = new THREE.Plane();
                plane.setFromNormalAndCoplanarPoint(endNormal, this._endPos);
                let intersection: THREE.Vector3 = new THREE.Vector3();
                plane.projectPoint(this._startPos, intersection);

                // Points for mesh
                let points: Array<THREE.Vector3> = [];
                points = points.concat(spline.getPoints(9));
                newPoints = [];
                for (let i = 0; i < points.length - 1; ++i) {
                    newPoints.push(points[i].x, points[i].y, points[i].z);
                }
                newPoints.push(this._endPos.x, this._endPos.y, this._endPos.z);
            }

            // Creating Arc line
            let lineGeom = new LineGeometry();
            lineGeom.setPositions(newPoints);
            const matLine = new LineMaterial({
                color: 0x000000,
                linewidth: 0.005, // in pixels
                dashed: false
            });
            this._mainMeasurement = new Line2(lineGeom, matLine);
            this._mainMeasurement.computeLineDistances();
            this._mainMeasurement.scale.set(1, 1, 1);
            this._mainMeasurement.layers.enable(1);
            this._mainMeasurement.layers.set(ViewerLayers.INFO);
            this._mainMeasurement.position.copy(midpoint);
        }
        catch (err) {
            console.error(err);
        }

    }

    updatePoints(startPos: THREE.Vector3, endPos: THREE.Vector3, startNormal: THREE.Vector3, endNormal: THREE.Vector3) {
        // Start and end point
        // Getting arc point based on the 2 normals
        let midpoint = startPos.clone().add(endPos).divideScalar(2);
        this._startPos = startPos.clone().sub(midpoint);
        this._endPos = endPos.clone().sub(midpoint);
        this._startNormal = startNormal;
        this._endNormal = endNormal;
        this.value = this._startNormal.angleTo(this._endNormal) * MathUtils.RAD2DEG;
        var newPoints: number[];
        if (this._startPos.distanceToSquared(this._endPos) < 1) {
            newPoints = [this._startPos.x, this._startPos.y, this._startPos.z];
        }
        else {

            // Getting the intersection point
            let planeControl = new THREE.Plane();
            planeControl.setFromNormalAndCoplanarPoint(endNormal, this._startPos);
            let controlPoint: THREE.Vector3 = new THREE.Vector3();
            planeControl.projectPoint(this._endPos, controlPoint);


            // Making an arc for the angle
            const spline = new THREE.QuadraticBezierCurve3(this._startPos, controlPoint, this._endPos);

            // Getting the intersection point
            let plane = new THREE.Plane();
            plane.setFromNormalAndCoplanarPoint(endNormal, this._endPos);
            let intersection: THREE.Vector3 = new THREE.Vector3();
            plane.projectPoint(this._startPos, intersection);

            // Points for mesh
            let points: Array<THREE.Vector3> = [];
            points = points.concat(spline.getPoints(9));
            newPoints = [];
            for (let i = 0; i < points.length - 1; ++i) {
                newPoints.push(points[i].x, points[i].y, points[i].z);
            }
            newPoints.push(this._endPos.x, this._endPos.y, this._endPos.z);
        }


        // Creating Arc line
        let lineGeom = new LineGeometry();
        lineGeom.setPositions(newPoints);
        this._mainMeasurement.geometry = lineGeom;
        this._mainMeasurement.position.copy(midpoint);
        this._mainMeasurement.computeLineDistances();
    }

    addLabels(svgOverlay: SVGOverlay): SVGLabel[] {
        let worldPos = this._mainMeasurement.getWorldPosition(new THREE.Vector3());
        // Create label in worldspace
        this.value = this._startNormal.angleTo(this._endNormal) * MathUtils.RAD2DEG;
        return [svgOverlay.createLabel(12, this.value.toFixed(2).toString() + "°", worldPos, { fontColor: 'white', background: 'black', border: 'grey', stroke: 'white' })];
    }

    getData(): MeasurementData {
        return {
            measurement:'angle',
            startPos: this._startPos,
            endPos: this._endPos,
            startNormal: this._startNormal,
            endNormal: this._endNormal
        }
    }
}